












































































































































































































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  DataSet,
  DataSetRule,
  DeviceType,
  DeviceVersionRule,
  Integration,
  IntegrationConfiguration,
  SchemaField,
} from '@/types';
import DataSetService from '@/services/dataset.service';
import { Action, Getter, Mutation } from 'vuex-class';
import QueryBuilder from 'query-builder-vue';
import RuleInput from '@/components/conditionbuilder/RuleInput.vue';
import Rule from '@/components/conditionbuilder/Rule.vue';
import DeviceTypeService from '@/services/devicetype.service';
import Table from '@/components/Table.vue';
import { copyToClipboard } from '@/classes/utils';
import Spinner from '@/components/Spinner.vue';

@Component({
  components: {
    Table,
    Rule,
    QueryBuilder,
    Spinner,
  },
})
export default class EventRules extends Vue {
  @Getter private hasPermission: any;

  private datasets: DataSet[] = [];
  private selectedDataset: DataSet = {name: '', filters: '', streaming: false, publishing: false, query: false, owner: ''};
  private deviceTypes: any[] = [];
  private deviceTypesForDataset: DeviceType[] = [];
  private rulesForDataset: any[] = [];
  private active: number = 1;

  private addDialog: boolean = false;
  private preventSave: boolean = true;
  private dragging: boolean = true;
  private adding: boolean = true;
  private validate: number = 0;
  private hasOperator: boolean = false;
  private hasChildren: boolean = false;
  private selectedMessageType: string = '';
  private nameError: boolean = false;
  private messageTypes: any[] = [];
  private rules: any[] = [];
  private currentRulePanel: number = -1;
  private severity: string[] = ['info', 'warning', 'critical'];
  private query: any = null;
  private config: any =  {
    operators: [
      { name: '', identifier: '' },
      { name: 'ANY', identifier: 'ANY' },
      { name: 'ALL', identifier: 'ALL' },
    ],
    rules: [],
    dragging: {
      animation: 300,
      disabled: !this.dragging,
      dragClass: 'sortable-drag',
    },
  };

  private showNoDatasetsMessage: boolean = true;
  private showEditor: boolean = false;
  private newRule: any = {};
  private editCopy: any = {};
  private dialogWidth: string = '450';
  private step: number = 1;
  private bus: any = new Vue();
  private loading: boolean = true;
  private tableData: any = {
    headers: [
      {text: 'Name', value: 'name', align: 'start', filterable: true},
      {text: 'Dataset', value: 'dataset_name'},
      {text: 'Integrations', value: 'integrations'},
      {text: '', value: 'actions', align: 'end'},
    ],
    total: 0,
    filters: {},
    distinctRows: {},
    rows: [],
  };
  private search: string = '';

  private copyToClipboard: (text: string) => boolean = copyToClipboard;

  @Action private addToastErrorMessage: any;

  private async mounted() {
    try {
      this.loading = true;
      const datasets = await DataSetService.getDataSets();

      const deviceTypes = await DeviceTypeService.getCatalogue();

      if (datasets) {
        await this.populateRules(datasets);
        Vue.set(this, 'datasets', datasets);
      }

      Vue.set(this, 'deviceTypes', deviceTypes);
    } finally {
      this.loading = false;
    }

  }

  private updateActive(index: number) {
    this.active = index;
  }

  @Watch('query')
  private onQueryChange(query: any) {
    this.validate++;
    if (query && query.children && query.children.length) {
      return this.hasChildren = true;
    } else {
      return this.hasChildren = false;
    }
  }

  private async populateRules(datasets: DataSet[]) {
    if (datasets && datasets.length) {
        const datasetIds: number[] = datasets.map((d: DataSet) => Number(d.id));
        const rulesForAllDatasets = await DataSetService.getRulesForAllDatasets(datasetIds);
        const integrationsForAllDatasets = await DataSetService.getIntegrationsForAllDatasets(datasetIds);
        let rules: DataSetRule[] = [];

        for (const group in rulesForAllDatasets) {
          if (rulesForAllDatasets.hasOwnProperty(group)) {
            rules.push(...rulesForAllDatasets[group]);
          }
        }

        rules = rules.map((rule: DataSetRule) => {
          const newRule: any = rule;
          const dataset = datasets.find((ds: DataSet) => ds.id === rule.dataset_id);
          if (dataset) {
            newRule.dataset_name = dataset.name;
            if (integrationsForAllDatasets) {
              for (const integrations in integrationsForAllDatasets) {
                if (integrationsForAllDatasets.hasOwnProperty(integrations)) {
                  if (Number(integrations) === rule.dataset_id) {
                    newRule.integrations = integrationsForAllDatasets[integrations].map((i: IntegrationConfiguration) => {
                      return { name: i.integration.name, icon: i.integration.type };
                    });
                  }
                }
              }
            }
          }
          return newRule;
        });

        if (rules.length) {
          const rows: any[] = [];
          rules.forEach((row: DataSetRule) => {
            rows.push({
              id: row.id,
              name: row.name,
              dataset_id: row.dataset_id,
              dataset_name: row.dataset_name,
              integrations: row.integrations,
              device_version_slug: row.device_version_slug,
              desc: row.desc,
              conditions: row.conditions,
              message: row.message,
              message_type: row.message_type,
              severity: row.severity,
              uuid: row.uuid,
            });
          });
          Vue.set(this.tableData, 'rows', rows);
          Vue.set(this, 'rules', rules);
        } else {
          Vue.set(this.tableData, 'rows', []);
        }
        this.showNoDatasetsMessage = false;
    } else {
      this.showNoDatasetsMessage = true;
    }
  }

  private getDeviceTypes(datasetId: number) {
    const currDataset = this.datasets.find((d: DataSet) => d.id === datasetId);

    if (currDataset) {
      const slugs = JSON.parse(currDataset.filters).deviceTypes;
      if (slugs) {
        Vue.set(this, 'deviceTypesForDataset', slugs.flatMap((deviceTypeSlug: string) => this.deviceTypes.filter((deviceType: any) => deviceType.slug === deviceTypeSlug)));

      } else {
        Vue.set(this, 'deviceTypesForDataset', this.deviceTypes);
      }
    }
  }

  private checkForAddRule() {
    if (this.datasets.length) {
      this.addRule();
      this.addDialog = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          (this.$refs.form as any).reset();
        }
      });
    } else {
      this.addToastErrorMessage('No available data sets to create a rule.');
    }
  }

  private addRule() {
    this.query = null;
    this.hasOperator = false;

    const newRule = {
      conditions: {
        operatorIdentifier: '',
        children: {},
      },
      name: '',
    };

    Vue.set(this, 'newRule', newRule);
    this.rules.push(newRule);
  }

  private goToNextStep() {
    this.step++;

    if (this.step === 2) {
      if (this.$vuetify.breakpoint.width < 1200) {
        this.dialogWidth = '70vw';
      } else {
        this.dialogWidth = '50vw';
      }
    }
  }
  private goToPreviousStep() {
    this.step--;

    if (this.step === 1) {
      this.dialogWidth = '450';
    }
  }

  private convertDeviceTypeSlugToId(slug: string) {
    return this.deviceTypes.find((deviceType: any) => deviceType.slug === slug);
  }

  private async getMessageTypes(rule: DataSetRule) {
    if (rule.device_version_slug) {
      const deviceType = this.convertDeviceTypeSlugToId(rule.device_version_slug);
      const dt: any = await DeviceTypeService.getCatalogueDeviceType(deviceType.id);
      if (dt.schema_fields) {
        const messages = dt.schema_fields.filter((schema: SchemaField) => schema.direction === 'uplink');
        Vue.set(this, 'messageTypes', this.groupMessageTypes(messages));
      }
      this.showEditor = false;
    }
  }

  private groupMessageTypes(messages: SchemaField[], selected: string = '') {
    const grouped = messages.reduce((acc: any, d) => {
      if (Object.keys(acc).includes(d.message_type)) { return acc; }

      acc[d.message_type] = messages.filter((g: SchemaField) => g.message_type === d.message_type);
      return acc;
    }, {});

    const groupedMessages: any[] = [];
    for (const key in grouped) {
      if (grouped.hasOwnProperty(key)) {
        const obj = {name: key, messages: grouped[key]};
        groupedMessages.push(obj);
      }
    }
    if (!selected) {
      return groupedMessages;
    } else {
      return groupedMessages.filter((messageType: any) => messageType.name === selected);
    }
  }

  private getFields(rule: any) {
    this.selectedMessageType = rule.message_type;

    let metricsForMessageType = this.messageTypes.filter((type) => type.name === rule.message_type);
    metricsForMessageType = metricsForMessageType.flatMap((type) => type.messages.map((field: SchemaField) => ({name: field.fieldName})));

    Vue.set(rule, 'metrics', metricsForMessageType);

    this.showEditor = true;
  }

  private addCondition(props: any) {
    let condition = {};
    if (this.selectedMessageType !== '') {
      condition = {
        identifier: 'field',
        name: '',
        component: RuleInput,
        initialValue: () => { return {
          fact: '',
          path: '',
          operation: '',
          value: null,
        }; },
      };
      this.config.rules.push(condition);
    }
    props.addRule('field');
  }

  private async editRule(rule: DataSetRule) {
    this.editCopy = JSON.parse(JSON.stringify(rule));

    this.adding = false;
    this.addDialog = true;
    Vue.set(this, 'newRule', rule);

    this.populateRule(rule);
    this.getDeviceTypes(rule.dataset_id);
    await this.getMessageTypes(rule);
    this.getFields(rule);

    Vue.set(this, 'query', rule.conditions);
    this.showEditor = true;
  }

  private preventSaving(prevented: boolean) {
    this.preventSave = prevented;
  }

  private async deleteRule(rule: DataSetRule) {
    if (rule.id) {
      await DataSetService.deleteDatasetRule(Number(rule.dataset_id), rule.id);
    }
    Vue.set(this, 'rules', this.rules.filter((r: DataSetRule) => rule.id ? rule.id !== r.id : rule.name !== r.name));
    await this.populateRules(this.datasets);
  }

  private async populateRule(rule: any) {
    if (typeof rule.id !== 'undefined') {

      if (rule.conditions && rule.conditions.children && Object.values(rule.conditions.children).length) {
        for (const c of rule.conditions.children) {

          this.hasOperator = true;

          const dbRule = {
            identifier: 'field',
            name: '',
            component: RuleInput,
            initialValue: () => {
              return {
                fact: '',
                path: '',
                operation: '',
                value: null,
              };
            },
          };
          this.config.rules.push(dbRule);
        }
        this.query = rule.conditions;
      }
    } else {
      this.query = null;
    }
  }

  private async saveRule(r: DataSetRule) {
    const newRule = {
      name: r.name,
      dataset_id: Number(r.dataset_id),
      dataset_name: r.dataset_name,
      integrations: r.integrations,
      desc: r.desc,
      device_version_slug: r.device_version_slug,
      conditions: {},
      message: r.message,
      severity: r.severity,
      message_type: r.message_type,
    };
    newRule.conditions = this.query;

    r.id
      ? await DataSetService.updateDatasetRule(Number(r.dataset_id), r.id, newRule)
      : await DataSetService.createDatasetRule(Number(r.dataset_id), newRule);

    this.resetDialog();
    await this.populateRules(this.datasets);
  }

  private resetDialog() {
    this.addDialog = false;
    this.step = 1;
    this.dialogWidth = '450';
    this.showEditor = false;
    this.preventSave = true;
    this.adding = false;
  }

  private validateFields() {
    (this.$refs.form as any).validate();
    (this.$refs.form as any).resetValidation();
  }

  private get nameRules() {
    const rules: any[] = [];

    rules.push(
      (v: string) => v && !!v || 'Rule name is required',
      (v: string) => {
        if (this.rules.filter((n) => n.name === v).length > 1) {
          this.nameError = true;
          return `Name "${v}" already exists`;
        } else {
          this.nameError = false;
          return true;
        }
      });
    return rules;
  }

  private integrationFilter(values: string | any[], search: string, item: object) {
    let matched: boolean = false;
    if (!search) {
      matched = true;
    } else {
      if (values && typeof values === 'string') {
        if (values.toString().indexOf(search) !== -1) {
          matched = true;
        }
      } else if (values && Array.isArray(values)) {
        for (const integration of values) {
          if (integration.name.toString().indexOf(search) !== -1) {
            matched = true;
            break;
          }
        }
      }
    }
    return matched;
  }

  private get tableDataRowCount(): number {
    if (this.tableData && this.tableData.rows) {
      return this.tableData.rows.length;
    }
    return 0;
  }

  private close() {
    const index = this.tableData.rows.findIndex((r: DataSetRule) => r.id === this.editCopy.id);
    Vue.set(this.tableData.rows, index, {...this.editCopy});

    if (this.step === 1) {
      this.validateFields();
    }
    this.resetDialog();
  }
}

